import { ReactNode, useCallback, useState } from "react";
import { AuthContext, AuthContextType } from "../context/AuthContext";

const SELECTED_ORG_STORAGE_KEY = "selectedOrganizationId";

interface AuthProviderProps {
    children: ReactNode;
}

function resolveSelectedOrganization(organizations: any[]) {
    if (!organizations.length) return null;
    const savedId = sessionStorage.getItem(SELECTED_ORG_STORAGE_KEY);
    return organizations.find((org) => org.Id === savedId) || organizations[0];
}

export const AuthProvider = ({ children }: AuthProviderProps) => {
    const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
    const [token, setToken] = useState<string | null>(null);
    const [roles, setRoles] = useState<any[]>([]);
    const [organizations, setOrganizationsState] = useState<any[]>([]);
    const [selectedOrganization, setSelectedOrganizationState] = useState<any | null>(null);
    const [user, setUser] = useState<any>();

    const setOrganizations = useCallback((value: any[]) => {
        const next = Array.isArray(value) ? value : [];
        setOrganizationsState(next);
        const selected = resolveSelectedOrganization(next);
        setSelectedOrganizationState(selected);
        if (selected?.Id) {
            sessionStorage.setItem(SELECTED_ORG_STORAGE_KEY, selected.Id);
        } else {
            sessionStorage.removeItem(SELECTED_ORG_STORAGE_KEY);
        }
    }, []);

    const setSelectedOrganization = useCallback((value: any | null) => {
        setSelectedOrganizationState(value);
        if (value?.Id) {
            sessionStorage.setItem(SELECTED_ORG_STORAGE_KEY, value.Id);
        } else {
            sessionStorage.removeItem(SELECTED_ORG_STORAGE_KEY);
        }
    }, []);

    const contextValue: AuthContextType = {
        isAuthenticated,
        user,
        setIsAuthenticated,
        setUser,
        token: token,
        roles: roles,
        organizations: organizations,
        selectedOrganization: selectedOrganization,
        setToken: setToken,
        setRoles: setRoles,
        setOrganizations: setOrganizations,
        setSelectedOrganization: setSelectedOrganization,
    };

    return <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>;
};
